/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbastecimentoBemListComponent } from "./abastecimento-bem-list/abastecimento-bem-list.component";
import { editRoute, newRoute } from "../../shared/services/data.service";
import { AbastecimentoBemFormComponent } from "./abastecimento-bem-form/abastecimento-bem-form.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class AbastecimentoBensRoutingModule {}


export const abastecimentoBensRoutes: any[] = [
    {
        path: '',
        component: AbastecimentoBemListComponent
    },{
        path: editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: newRoute,
        component: AbastecimentoBemFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/abastecimento-bens-routing.module.ts
 **/